import { useMutation } from '@tanstack/react-query';

import { previewDiscount } from '~/services/PromoService';

export function useQuickDiscount() {
  return useMutation({ mutationKey: ['promo', 'quick-discount'], mutationFn: previewDiscount, retry: false });
}
